import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyUnit } from '@/context/CurrencyContext';

export interface CurrencyToggleProps {
    active: CurrencyUnit;
    onChange: (unit: CurrencyUnit) => void;
}

const UNITS: CurrencyUnit[] = ["None", "Tkr", "Mkr"];

const CurrencyToggle: FC<CurrencyToggleProps> = ({ active, onChange }) => {
    const { t } = useTranslation("common");

    return (
        <div className="inline-flex items-center justify-center h-10 rounded-xl bg-gray-175 border border-gray-200 p-1">
            {UNITS.map(unit => {
                const isActive = active === unit;
                return (
                    <button
                        key={unit}
                        type="button"
                        onClick={() => onChange(unit)}
                        className={`flex items-center justify-center gap-1 px-3 h-8 text-sm rounded-lg transition-all ${isActive
                            ? 'bg-white text-black shadow-sm'
                            : 'text-gray-500 hover:text-black'
                            }`}
                    >
                        {unit === "None" ? t("none") : unit}
                    </button>
                );
            })}
        </div>
    );
};

export default CurrencyToggle;